/**
 * Standardizes debate format codes across the app
 * @param format The format code to standardize
 * @returns Standardized format code (BP or AP)
 */
export const standardizeFormat = (format: string | undefined): string => {
  if (!format) return 'BP'; // Default to BP if format is undefined
  
  const upperFormat = format.toUpperCase();
  
  if (upperFormat === 'ABP' || upperFormat === 'BP') {
    return 'BP';
  }
  
  if (upperFormat === 'PDA') {
    return 'PDA';
  }
  
  if (upperFormat === 'AP3' || upperFormat === 'AP') {
    return 'AP';
  }
  
  return format;
};

/**
 * Gets a display name for a debate format
 * @param format The format code
 * @returns Human-readable format name
 */
export const getFormatDisplay = (format: string | undefined): string => {
  const standardFormat = standardizeFormat(format);
  
  if (standardFormat === 'BP') {
    return 'British Parliamentary';
  }
  
  if (standardFormat === 'AP') {
    return 'Asian Parliamentary';
  }
  
  if (standardFormat === 'PDA') {
    return 'PDA Parliamentary';
  }
  
  return format || 'Unknown Format';
};

/**
 * Safely renders motion content whether it's a string or an object
 * @param motion - Motion data which could be a string or object with text property
 * @returns Formatted motion text as string
 */
export const formatMotion = (motion: any): string => {
  if (!motion) return 'No motion available';
  
  if (typeof motion === 'object' && motion !== null) {
    return motion.text || 'No motion text available';
  }
  
  return String(motion);
};